var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
import tailwind from '@/tailwind.config';
import lchPlugin from 'colord/plugins/lch';
import { colord, extend } from 'colord';
extend([lchPlugin]);
var BrandingSettingsColors = /** @class */ (function (_super) {
    __extends(BrandingSettingsColors, _super);
    function BrandingSettingsColors() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * This is our primary color that the user chooses.
         * It will also be used as the base color when we
         * generate the safe light and dark colors for
         * use in the form viewer pages.
         */
        _this.primary = tailwind.theme.colors.purple;
        _this.light = null;
        _this.dark = null;
        return _this;
    }
    Object.defineProperty(BrandingSettingsColors.prototype, "safeBrandingColors", {
        /**
         * Generate colors from the base (primary property)
         * to get safe colors in terms of accesibility.
         */
        get: function () {
            var base = colord(this.primary);
            var light = colord({
                l: 90,
                c: Math.min(22, base.toLch().c * 0.5),
                h: base.toLch().h,
            }).toHex();
            var dark = colord({
                l: 25,
                c: base.toLch().c,
                h: base.toLch().h,
            }).toHex();
            return {
                primary: base.toHex(),
                light: light,
                dark: dark,
            };
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BrandingSettingsColors.prototype.fromJson = function (jsonData) {
        var data = _super.prototype.fromJson.call(this, jsonData);
        /**
         * If incoming jsonData has dark or light we want to use them.
         * if they are null we want to create some safe brand colors
         * based on their primary color.
         */
        this.primary = data.primary ? data.primary : tailwind.theme.colors.purple;
        this.dark = data.dark ? data.dark : this.safeBrandingColors.dark;
        this.light = data.light ? data.light : this.safeBrandingColors.light;
        return data;
    };
    return BrandingSettingsColors;
}(Entity));
export { BrandingSettingsColors };
